import * as api from '../../services/evt'
import lodash from 'lodash'

export const FETCH_EVTS = 'FETCH_EVTS';
export const FETCH_EVT = 'FETCH_EVT';
export const FETCH_OPERTION_EVT = 'FETCH_OPERTION_EVT';
export const STORE_EVTS_COLUMNS = 'SET_EVTS_COLUMNS';
export const REPLACE_EVT_IN_EVTS = 'REPLACE_EVT_IN_EVTS';
export const WX_LEVEL_SHARE_ATTENDEES = 'WX_LEVEL_SHARE_ATTENDEES';


export const fetchEvt = (id) => {
    return {
        type: FETCH_EVT,
        payload: {
            promise: api.findEvent({id: id})
        }
    }
}


export const fetchEvtWithViewedCounted = (id) => {
    return {
        type: FETCH_EVT,
        payload: {
            promise: api.findEventWithViewedCounted({id: id})
        }
    }
}


export const storeEvtsColumns = (columns) => ({type: STORE_EVTS_COLUMNS, columns});

export const replaceEvtInEvts = (evtId, evt) => {
    return {
        type: REPLACE_EVT_IN_EVTS,
        evtId,
        evt,
    }
};
export const addWxLevelShareAttendees = (data=[]) => {
    return {
        type: WX_LEVEL_SHARE_ATTENDEES,
        data,
    }
};
export const fetchPublishedEvts = (params, pagination, sort, extra) => {
    const _params = Object.assign(params, {"published": true})
    return fetchEvts(_params, pagination, sort, extra);
}

export const fetchUnpublishedEvts = (params, pagination, sort, extra) => {
    const _params = Object.assign(params, {"published": false})
    return fetchEvts(_params, pagination, sort, extra);
}

export const fetchEvts = (params, pagination, sort, extra) => {
    return {
        type: FETCH_EVTS,
        payload: {
            promise: api.findEvents(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: lodash.omit(params, 'ownership','idOrName','happenStatus','uniqueFieldValue','guestGroupIds'),
            sort: sort,
            extra: extra
        }
    }
}









// WEBPACK FOOTER //
// ./src/redux/actions/evt.js